// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"508f6b6c","479":"4a2cd2b0","838":"fae75b15"}[chunkId] + ".js";
};